"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var text = {
  primary: 'rgba(0, 0, 0, 0.94)',
  secondary: 'rgba(0, 0, 0, 0.54)',
  disabled: 'rgba(0, 0, 0, 0.24)',
  hint: 'rgba(0, 0, 0, 0.44)'
};
exports["default"] = text;